module.exports = __webpack_public_path__ + "img/iconMode.2e761634.svg";